import { EditablePage, ProvideAll, config } from '@ds-mgnl/marketing';
import { useLoaderData } from 'react-router-dom';

export function MagnoliaPage() {
	const { pageJson } = useLoaderData() as { pageJson: unknown };

	return (
		<ProvideAll>
			<EditablePage
				templateAnnotations={{}}
				content={pageJson}
				config={config}
			></EditablePage>
		</ProvideAll>
	);
}
